var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 10C6.375 11.207 5.39453 12.1875 4.1875 12.1875C2.98047 12.1875 2 11.207 2 10C2 8.79297 2.98047 7.8125 4.1875 7.8125C5.39453 7.8125 6.375 8.79297 6.375 10ZM12.625 10C12.625 11.207 11.6445 12.1875 10.4375 12.1875C9.23047 12.1875 8.25 11.207 8.25 10C8.25 8.79297 9.23047 7.8125 10.4375 7.8125C11.6445 7.8125 12.625 8.79297 12.625 10ZM16.6875 12.1875C15.4805 12.1875 14.5 11.207 14.5 10C14.5 8.79297 15.4805 7.8125 16.6875 7.8125C17.8945 7.8125 18.875 8.79297 18.875 10C18.875 11.207 17.8945 12.1875 16.6875 12.1875Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsIcon);
export default __webpack_public_path__ + "static/media/dots-icon.08f8b373344dec55aa993b67a24a5d87.svg";
export { ForwardRef as ReactComponent };